import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface MultiSelectProps extends KendoWidgetProps, kendo.ui.MultiSelectOptions {
    children?: React.ReactNode;
}

export default class MultiSelect extends KendoBaseComponent<MultiSelectProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.MultiSelect(domNode as Element, (props as kendo.ui.MultiSelectOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, dataSource, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            const widget = (this.widgetInstance as kendo.ui.MultiSelect);

            if (widget.options.dataSource !== dataSource) {
                widget.setDataSource(dataSource);
            }
            widget.value(this.props.value);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'select'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <select ref={this.elementRef} />;
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-react-wrapper/src/multiselect/index.tsx